import { PROJECTS } from './projects'

export const PORTFOLIO_YEARS = 6
export const PORTFOLIO_PROJECTS_SHIPPED = 25
export const PORTFOLIO_COMMITS = 4500
export const PORTFOLIO_CASE_STUDIES = PROJECTS.length

export const PORTFOLIO_STACK = [
  'React',
  'Next.js',
  'TypeScript',
  'Solana',
  'Three.js',
  'MongoDB',
  'Redis',
  'Stripe',
] as const

export const PORTFOLIO_LIVE_PRODUCT = {
  name: 'Kitcord',
  label: 'Live product',
} as const

export type MarqueeItem = {
  value: string
  label: string
}

function pairStackItems(items: readonly string[]): MarqueeItem[] {
  const pairs: MarqueeItem[] = []
  for (let i = 0; i < items.length; i += 2) {
    pairs.push({
      value: items[i],
      label: items[i + 1] ?? 'Stack',
    })
  }
  return pairs
}

export const MARQUEE_ITEMS: MarqueeItem[] = [
  { value: `${PORTFOLIO_YEARS}+`, label: 'Years' },
  { value: `${PORTFOLIO_PROJECTS_SHIPPED}+`, label: 'Shipped' },
  { value: '4.5k', label: 'Commits' },
  { value: String(PORTFOLIO_CASE_STUDIES), label: 'Case studies' },
  ...pairStackItems(PORTFOLIO_STACK),
  { value: PORTFOLIO_LIVE_PRODUCT.name, label: PORTFOLIO_LIVE_PRODUCT.label },
]

export function formatCommitCount(value: number): string {
  if (value >= 1000) return `${(value / 1000).toFixed(1)}k`
  return String(value)
}
